var idCounter = 0;
export default (function (prefix) {
    var id = ++idCounter;
    return "".concat(prefix, "-").concat(id);
});
//# sourceMappingURL=uniqueId.js.map